import Header from "@/components/header/Header.vue";
import Footer from "@/components/footer/Footer.vue";
import { useToast } from "vue-toastification";
import axios from "@/config/axios";
import { EMOJI_CATEGORIES, FUNNY_STICKERS, parseStickerContent, getStickerThemeClass } from "@/constants/emojiStickers";

export default {
  name: "BookSuggest",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      // Form state
      showForm: false,
      isSubmitting: false,
      form: {
        bookName: '',
        bookContent: '',
        authorName: '',
        reviewContent: '',
        isSpoil: false,
        evaluateNumber: null,
        note: '',
        currentPage: 0,
        totalPage: 0,
        percent: 0,
        noteType: false, // false = pages, true = percent
        progressStatus: null,
        ownStatus: null
      },
      hoverRating: 0,

      // Sections collapse (for mobile)
      showReviewSection: false,
      showProgressSection: false,

      // My suggestions list
      mySuggests: [],
      isLoading: false,
      currentPage: 0,
      totalPages: 0,
      totalElements: 0,

      // View detail modal
      showDetailModal: false,
      detailItem: null,

      // Emoji & Sticker Picker
      showEmojiPicker: false,
      emojiPickerTab: 'emojis',
      emojiPickerSearch: '',
      emojiPickerPos: { top: '0px', left: '0px' },
      emojiCategories: EMOJI_CATEGORIES,
      funnyStickers: FUNNY_STICKERS,
      activePickerTarget: null,
      selectedStickersMap: {},

      // Status options
      progressStatuses: [
        { value: 0, label: 'Chưa đọc', icon: 'fa-solid fa-book' },
        { value: 1, label: 'Muốn đọc', icon: 'fa-solid fa-bookmark' },
        { value: 2, label: 'Đang đọc', icon: 'fa-solid fa-book-open-reader' },
        { value: 3, label: 'Đã đọc xong', icon: 'fa-solid fa-circle-check' },
        { value: 4, label: 'Tạm ngưng', icon: 'fa-solid fa-pause' }
      ],
      ownStatuses: [
        { value: 0, label: 'Chưa sở hữu', icon: 'fa-solid fa-circle-question' },
        { value: 1, label: 'Sách giấy', icon: 'fa-solid fa-book' },
        { value: 2, label: 'Ebook', icon: 'fa-solid fa-tablet-screen-button' }
      ]
    };
  },
  computed: {
    formValid() {
      return this.form.bookName && this.form.bookName.trim().length > 0;
    },
    hasReviewedOrRated() {
      return !!(this.form.evaluateNumber || (this.form.reviewContent && this.form.reviewContent.trim().length > 0));
    },
    filteredStickers() {
      const q = (this.emojiPickerSearch || '').toLowerCase().trim();
      if (!q) return this.funnyStickers;
      return this.funnyStickers.filter(st =>
        (st.name && st.name.toLowerCase().includes(q)) ||
        (st.code && st.code.toLowerCase().includes(q))
      );
    },
    progressPercent() {
      if (this.form.noteType) {
        return Math.min(100, Math.max(0, this.form.percent || 0));
      }
      if (this.form.totalPage > 0) {
        return Math.min(100, Math.round((this.form.currentPage / this.form.totalPage) * 1000) / 10);
      }
      return 0;
    }
  },
  watch: {
    hasReviewedOrRated(newVal) {
      if (newVal) {
        if (this.form.progressStatus === null || this.form.progressStatus === 0 || this.form.progressStatus === 1) {
          this.form.progressStatus = 3;
        }
      }
    }
  },
  mounted() {
    this.loadMySuggests();
    document.addEventListener('click', this.handleDocumentEmojiClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentEmojiClick);
  },
  methods: {
    // ── EMOJI & STICKER PICKER ──────────────────────────────────────────────
    handleDocumentEmojiClick(e) {
      if (!this.showEmojiPicker) return;
      const popover = document.querySelector('.emoji-sticker-picker-popover');
      const triggers = document.querySelectorAll('.btn-emoji-trigger');
      let isTrigger = false;
      triggers.forEach(t => {
        if (t.contains(e.target)) isTrigger = true;
      });
      if (popover && !popover.contains(e.target) && !isTrigger) {
        this.closeEmojiPicker();
      }
    },
    formatContentHtml(str) {
      return parseStickerContent(str, this.funnyStickers);
    },
    toggleEmojiPicker(targetKey, event) {
      if (this.showEmojiPicker && this.activePickerTarget === targetKey) {
        this.closeEmojiPicker();
        return;
      }
      this.activePickerTarget = targetKey;
      this.showEmojiPicker = true;
      this.emojiPickerTab = 'emojis';
      this.emojiPickerSearch = '';

      if (event && event.currentTarget) {
        const rect = event.currentTarget.getBoundingClientRect();
        const popoverHeight = 365;

        if (rect.top > 120) {
          const topPos = Math.max(10, rect.top + window.scrollY - popoverHeight - 6);
          const leftPos = Math.min(window.innerWidth - 345, Math.max(10, rect.left + window.scrollX - 60));
          this.emojiPickerPos = {
            top: `${topPos}px`,
            left: `${leftPos}px`
          };
        } else {
          const topPos = rect.bottom + window.scrollY + 6;
          const leftPos = Math.min(window.innerWidth - 345, Math.max(10, rect.left + window.scrollX - 60));
          this.emojiPickerPos = {
            top: `${topPos}px`,
            left: `${leftPos}px`
          };
        }
      }
    },
    closeEmojiPicker() {
      this.showEmojiPicker = false;
      this.activePickerTarget = null;
    },
    insertEmoji(char) {
      this.form.reviewContent = (this.form.reviewContent || '') + char;
    },
    insertSticker(sticker) {
      if (!this.activePickerTarget) return;
      const currentList = this.selectedStickersMap[this.activePickerTarget] || [];
      if (currentList.length >= 5) {
        const toast = useToast();
        toast.warning('Bạn chỉ được chọn tối đa 5 sticker cho mỗi nhận xét!');
        return;
      }
      this.selectedStickersMap = {
        ...this.selectedStickersMap,
        [this.activePickerTarget]: [...currentList, sticker]
      };
    },
    removeSelectedSticker(target, index) {
      if (index === undefined) {
        const newMap = { ...this.selectedStickersMap };
        delete newMap[target];
        this.selectedStickersMap = newMap;
      } else {
        const currentList = this.selectedStickersMap[target] || [];
        const newList = currentList.filter((_, i) => i !== index);
        if (newList.length === 0) {
          const newMap = { ...this.selectedStickersMap };
          delete newMap[target];
          this.selectedStickersMap = newMap;
        } else {
          this.selectedStickersMap = {
            ...this.selectedStickersMap,
            [target]: newList
          };
        }
      }
    },
    getStickerThemeClass(sticker) {
      const text = typeof sticker === 'string' ? sticker : (sticker?.name || sticker?.code || '');
      return getStickerThemeClass(text);
    },
    getStickerString(target) {
      const stickers = this.selectedStickersMap[target] || [];
      return stickers.map(sticker => {
        if (sticker.name || sticker.code) return ` [sticker: ${sticker.name || sticker.code}] `;
        if (sticker.url) return ` [sticker: ${sticker.url}] `;
        return '';
      }).join('');
    },

    // ── FORM MANAGEMENT ─────────────────────────────────────────────────────
    toggleForm() {
      this.showForm = !this.showForm;
      if (this.showForm) {
        this.resetForm();
        this.$nextTick(() => {
          const el = this.$refs.formSection;
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    },
    resetForm() {
      this.form = {
        bookName: '',
        bookContent: '',
        authorName: '',
        reviewContent: '',
        isSpoil: false,
        evaluateNumber: null,
        note: '',
        currentPage: 0,
        totalPage: 0,
        percent: 0,
        noteType: false,
        progressStatus: null,
        ownStatus: null
      };
      this.hoverRating = 0;
      this.showReviewSection = false;
      this.showProgressSection = false;
      this.selectedStickersMap = {};
      this.activePickerTarget = null;
      this.showEmojiPicker = false;
    },

    // ── RATING ──────────────────────────────────────────────────────────────
    setRating(val) {
      this.form.evaluateNumber = this.form.evaluateNumber === val ? null : val;
    },
    selectProgressStatus(val) {
      if (this.hasReviewedOrRated && (val === 0 || val === 1)) {
        return;
      }
      this.form.progressStatus = this.form.progressStatus === val ? null : val;
    },

    // ── PROGRESS CALCULATION ────────────────────────────────────────────────
    calculatePercent() {
      if (!this.form.noteType && this.form.totalPage > 0) {
        this.form.percent = Math.min(100, Math.round((this.form.currentPage / this.form.totalPage) * 1000) / 10);
      }
    },
    onPercentInput() {
      this.form.percent = Math.min(100, Math.max(0, this.form.percent || 0));
    },
    setNoteType(isPercent) {
      this.form.noteType = isPercent;
    },

    hasAttachments(item) {
      return !!(item.evaluateNumber != null || item.reviewContent || item.note);
    },

    // ── SUBMIT ──────────────────────────────────────────────────────────────
    async submitSuggest() {
      if (!this.formValid || this.isSubmitting) return;
      const toast = useToast();

      this.isSubmitting = true;
      try {
        const payload = { ...this.form };
        if (payload.progressStatus === null) delete payload.progressStatus;
        if (payload.ownStatus === null) delete payload.ownStatus;
        payload.bookName = payload.bookName.trim();
        if (payload.bookContent) payload.bookContent = payload.bookContent.trim();
        if (payload.authorName) payload.authorName = payload.authorName.trim();
        if (payload.reviewContent) payload.reviewContent = payload.reviewContent.trim();
        if (payload.note) payload.note = payload.note.trim();

        const stickerText = this.getStickerString('suggestReview');
        if (stickerText) {
          payload.reviewContent = (payload.reviewContent || '') + stickerText;
        }

        const res = await axios.post('book-suggest/v1/create', payload);
        const { status, message } = res.data;

        if (status === '200') {
          toast.success(message || 'Gửi đề xuất thành công!');
          this.showForm = false;
          this.resetForm();
          this.loadMySuggests();
        } else {
          toast.error(message || 'Có lỗi xảy ra.');
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || 'Có lỗi xảy ra khi gửi đề xuất.');
      } finally {
        this.isSubmitting = false;
      }
    },

    // ── LOAD MY SUGGESTS ────────────────────────────────────────────────────
    async loadMySuggests(page = 0) {
      this.isLoading = true;
      try {
        const res = await axios.get('book-suggest/v1/my-suggests', { params: { page } });
        const { status, result } = res.data;
        if (status === '200' && result) {
          this.mySuggests = result.content || [];
          this.currentPage = result.number || 0;
          this.totalPages = result.totalPages || 0;
          this.totalElements = result.totalElements || 0;
        }
      } catch (err) {
        console.error('Error loading suggests:', err);
      } finally {
        this.isLoading = false;
      }
    },
    goToPage(page) {
      if (page >= 0 && page < this.totalPages) {
        this.loadMySuggests(page);
      }
    },

    // ── HELPERS ──────────────────────────────────────────────────────────────
    getStatusLabel(status) {
      const map = { 0: 'Chờ duyệt', 1: 'Đã duyệt', 2: 'Từ chối' };
      return map[status] || 'Không rõ';
    },
    getStatusClass(status) {
      const map = { 0: 'status-pending', 1: 'status-approved', 2: 'status-rejected' };
      return map[status] || '';
    },
    getProgressLabel(val) {
      if (val === null || val === undefined) return '—';
      const map = { 0: 'Chưa đọc', 1: 'Muốn đọc', 2: 'Đang đọc', 3: 'Đã đọc xong', 4: 'Tạm ngưng' };
      return map[val] ?? '—';
    },
    getOwnLabel(val) {
      if (val === null || val === undefined) return '—';
      const map = { 0: 'Chưa sở hữu', 1: 'Sách giấy', 2: 'Ebook' };
      return map[val] ?? '—';
    },
    formatDateTime(str) {
      if (!str) return '';
      const s = String(str).trim();
      if (/^\d{14}$/.test(s)) {
        const y = s.substring(0, 4);
        const m = s.substring(4, 6);
        const d = s.substring(6, 8);
        const h = s.substring(8, 10);
        const mn = s.substring(10, 12);
        const sec = s.substring(12, 14);
        return `${h}:${mn}:${sec} ${d}/${m}/${y}`;
      }
      if (/^\d{12}$/.test(s)) {
        const y = s.substring(0, 4);
        const m = s.substring(4, 6);
        const d = s.substring(6, 8);
        const h = s.substring(8, 10);
        const mn = s.substring(10, 12);
        return `${h}:${mn}:00 ${d}/${m}/${y}`;
      }
      if (/^\d{2}:\d{2}\s+\d{2}\/\d{2}\/\d{4}$/.test(s)) {
        const parts = s.split(/\s+/);
        return `${parts[0]}:00 ${parts[1]}`;
      }
      return s;
    },
    openDetail(item) {
      this.detailItem = item;
      this.showDetailModal = true;
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.detailItem = null;
    },
    visiblePages() {
      const range = [];
      const maxVisible = 5;
      let start = Math.max(0, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible);
      if (end - start < maxVisible) start = Math.max(0, end - maxVisible);
      for (let i = start; i < end; i++) range.push(i);
      return range;
    }
  }
};
